import {
	FormProvider,
	SubmitErrorHandler,
	SubmitHandler,
	useForm,
	useFormState
} from "react-hook-form";
import { ArrowLeft } from "lucide-react";
import { Button } from "src/components/ui/button";
import AppBrandingFormStepList from "../AppBrandingFormStepList/AppBrandingFormStepList";
import { Link } from "react-router-dom";
import { FC, useEffect } from "react";
import isEmpty from "lodash.isempty";

interface Props {
	onValidSubmit: SubmitHandler<Partial<AppBrand>>;
	onInvalidSubmit?: SubmitErrorHandler<Partial<AppBrand>>;
	defaultValues?: Partial<AppBrand>;
	isSubmitting?: boolean;
}

const CreateAppBrandingForm: FC<Props> = ({
	defaultValues,
	onValidSubmit,
	onInvalidSubmit,
	isSubmitting = false
}) => {
	const methods = useForm<Partial<AppBrand>>({
		mode: "onChange",
		reValidateMode: "onChange",
		defaultValues
	});

	const { reset, control, handleSubmit } = methods;

	const { isDirty, errors } = useFormState({ control });

	const isSubmitBtnDisabled = !isDirty || !isEmpty(errors) || isSubmitting;

	useEffect(() => {
		reset(defaultValues);
	}, [defaultValues]);

	return (
		<form
			onSubmit={handleSubmit(onValidSubmit, onInvalidSubmit)}
			onKeyDown={(e) => {
				if (e.key === "Enter" && e.target instanceof HTMLInputElement) {
					e.preventDefault();
				}
			}}
		>
			<FormProvider {...methods}>
				<AppBrandingFormStepList />
			</FormProvider>

			<div className="flex items-center justify-between pt-8 mt-8 border-t border-border">
				<Link
					to="/vendor-sponsorship/app-branding/brands?published=true"
					className="inline-flex items-center gap-1.5 text-sm text-zinc-500 hover:text-foreground transition-colors"
				>
					<ArrowLeft className="h-4 w-4" />
					Back to active app rebrand
				</Link>

				<Button type="submit" disabled={isSubmitBtnDisabled}>
					{isSubmitting ? (
						<div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
					) : (
						"Save"
					)}
				</Button>
			</div>
		</form>
	);
};

export default CreateAppBrandingForm;
